import { RouteInfo } from '../../../core/models/admin-template/sidebar-menu.data';
import { TemplateEngine } from '../../../core/services/active-template-engine.service';

// Site Routes

export const SROUTES: RouteInfo = {
  path: '/ecommerce/dashboard/dashboard/',
  title: 'sb_title',
  icon: 'bi bi-shop',
  class: 'has-sub',
  badge: '',
  badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
  isExternalLink: false,
  submenu: [
    {
      path: '/ecommerce/products/products-list/',
      title: 'sb_products',
      icon: 'bi bi-bag',
      class: 'has-sub',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [
        {
          path: '/ecommerce/products/products-list/',
          title: 'sb_products_list',
          icon: 'bi bi-card-list submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },

        {
          path: '/ecommerce/products/product-details/',
          title: 'sb_add_new_product',
          icon: 'bi bi-bag-plus submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },
        /*{
          path: '/ecommerce/products/product-details/',
          title: 'sb_product_details',
          icon: 'submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },*/
        {
          path: '/ecommerce/products/categories/categories-list/',
          title: 'sb_categories',
          icon: 'bi bi-diagram-3 submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },
      ],
    },
    {
      path: '/ecommerce/orders/orders-list/',
      title: 'sb_orders',
      icon: 'bi bi-box-seam',
      class: '',
      badge: '',
      badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
      isExternalLink: false,
      submenu: [
        /*{
          path: '/ecommerce/orders/orders-list/',
          title: 'Orders List',
          icon: 'ft-list submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },
        {
          path: '',
          title: 'Carts',
          icon: 'ft-shopping-cart submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },*/
      ],
    },
    {
      path: '/ecommerce/portal-design/portal-templates/',
      title: 'sb_web_config',
      icon: 'bi bi-palette',
      class: 'has-sub',
      badge: '',
      badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
      isExternalLink: false,
      submenu: [
        {
          path: '/ecommerce/portal-design/template/template-config/',
          title: 'Template',
          icon: 'bi bi-window-split submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },
        /*{
          path: '/ecommerce/portal-design/themes-config/',
          title: 'sb_themes',
          icon: 'bi bi-brush submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },*/
        {
          path: '/ecommerce/portal-design/menus/menus-config/',
          title: 'sb_menus',
          icon: 'bi bi-menu-button-fill submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        },
      ],
    },
    {
      path: '/ecommerce/media-library/',
      title: 'sb_media_library',
      icon: 'bi bi-images',
      class: '',
      badge: '',
      badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
      isExternalLink: false,
      submenu: [],
    },
    {
      path: '/ecommerce/shop-settings/nav-settings/',
      title: 'sb_settings',
      icon: 'bi bi-gear',
      class: '',
      badge: '',
      badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1',
      isExternalLink: false,
      submenu: [

      ],

    },
    {
      // `has-sub` solo mientras cuelgue algo de aquí: si el POS está apagado,
      // getSiteRoutes lo vacía Y devuelve la clase a '', para no dejar una
      // flecha de desplegable que no despliega nada.
      path: '/ecommerce/sales-channels/',
      title: 'sb_sales_channels',
      // `bi-broadcast` (un punto emitiendo en arcos) y no un escaparate: la sección no es UN
      // canal, es el reparto del MISMO catálogo por varios — hoy online y TPV, y el enum
      // SalesChannel ya contempla TikTok, Instagram y WhatsApp. Además `bi-shop-window` chocaba
      // con el `bi-shop` del primer nivel: dos escaparates casi idénticos a 16px en la misma
      // lista vertical. Se mantiene en la tarjeta del canal TPV de la ficha de producto, donde
      // sí significa literalmente "tienda física".
      icon: 'bi bi-broadcast',
      class: 'has-sub',
      badge: '',
      badgeClass: '',
      isExternalLink: false,
      submenu: [
        {
          // El POS cuelga de Canales de venta porque ES un canal de venta, no
          // un apartado hermano. Estuvo retirado del menú y solo se llegaba
          // entrando a Canales de venta -> "Ir al POS": dos clics y un rodeo
          // cada vez, para una pantalla que una tienda con caja abre a diario.
          //
          // La ruta acaba en `/` a propósito: la barra lateral construye la URL
          // como `path + site.id + '/' + site.site_name`, así que resuelve a
          // /ecommerce/pos/nav/<id>/<nombre>, que redirige a la pestaña por
          // defecto (ver pos-routing.module.ts).
          path: '/ecommerce/pos/nav/',
          title: 'sb_pos',
          icon: 'bi bi-cash-stack submenu-icon',
          class: '',
          badge: '',
          badgeClass: '',
          isExternalLink: false,
          submenu: [],
        }
      ],
    }
  ],
};

export function getSiteRoutes(
  engine: TemplateEngine,
  posEnabled: boolean = false,
  posFeatureEnabled: boolean = true,
): RouteInfo {
  const routes: RouteInfo = JSON.parse(JSON.stringify(SROUTES));

  // El POS solo aparece si (a) la feature flag de plataforma lo habilita para este usuario
  // (rollout: off / whitelist / everyone, resuelto en backend) y (b) la tienda lo tiene activado
  // (pos_enabled, opt-in del seller). Son dos ejes distintos; ambos deben cumplirse.
  //
  // Cuelga de "Canales de venta", así que hay que buscarlo DENTRO de ese
  // submenú, no en el primer nivel. Antes este bloque buscaba en el primer
  // nivel una entrada que ya no existía, y su findIndex devolvía -1 siempre:
  // era código muerto.
  if (!posEnabled || !posFeatureEnabled) {
    const channels = routes.submenu.find(item => item.path.includes('/sales-channels/'));
    if (channels) {
      channels.submenu = channels.submenu.filter(sub => !sub.path.includes('/pos/'));
      // Sin hijos deja de ser desplegable: si no, la plantilla pinta la clase
      // `has-sub` sobre un enlace plano y queda una flecha que no abre nada.
      if (channels.submenu.length === 0) {
        channels.class = '';
      }
    }
  }

  const designIndex = routes.submenu.findIndex(
    item => item.path.includes('/portal-design/')
  );
  if (designIndex === -1) return routes;

  const designItem = routes.submenu[designIndex];

  const templatesItem: RouteInfo = {
    path: '/ecommerce/portal-design/portal-templates/',
    title: 'sb_templates',
    icon: 'bi bi-grid-3x3-gap submenu-icon',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
  };

  if (engine === 'BASIC') {
    designItem.submenu = [
      templatesItem,
      {
        path: '/ecommerce/portal-design/template/template-config/',
        title: 'sb_editor',
        icon: 'bi bi-window-split submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
      {
        path: '/ecommerce/portal-design/menus/menus-config/',
        title: 'sb_navigation',
        icon: 'bi bi-menu-button-fill submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
    ];
  } else if (engine === 'THEME_WEAVER') {
    designItem.submenu = [
      templatesItem,
      {
        path: '/ecommerce/portal-design/design-studio/',
        title: 'sb_design_studio',
        icon: 'bi bi-gem submenu-icon',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
      },
    ];
  } else {
    designItem.submenu = [templatesItem];
  }

  return routes;
}

//Sidebar menu Routes and data
